<div class="container">
  <button
    class="no-style title-bar"
    [class.content-visible]="isContentVisible"
    [attr.aria-label]="(isContentVisible ? 'side-menu.menu-item.close' : 'side-menu.menu-item.open') | translate"
    (click)="toggle.emit()">
    <h3>{{ 'side-menu.' + header | translate }}</h3>
    <mat-icon
      class="toggle-icon"
      [class.open]="isContentVisible">
      keyboard_arrow_down
    </mat-icon>
  </button>
  @if (isContentVisible) {
    <div class="content">
      <ng-content></ng-content>
    </div>
  }
</div>
